/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        sideNav: {
            width: {
                value: "256px",
                type: "dimension",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: 0,
                            offsetY: "1px",
                            blur: "6px",
                            spread: "-2px",
                            color: "#00000023",
                        },
                    ],
                    stringValue: "0 1px 6px -2px #00000023",
                },
                type: "shadow",
            },
            collapsed: {
                width: {
                    value: "48px",
                    type: "dimension",
                },
            },
            header: {
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderBottomColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                paddingHorizontal: {
                    value: "4px",
                    type: "dimension",
                },
                menuButton: {
                    padding: {
                        value: "20px",
                        type: "dimension",
                    },
                },
                logo: {
                    height: {
                        value: "40px",
                        type: "dimension",
                    },
                },
            },
            navList: {
                paddingTop: {
                    value: "8px",
                    type: "dimension",
                },
                menuItem: {
                    gap: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingHorizontal: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingVertical: {
                        value: "12px",
                        type: "dimension",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    color: {
                        value: "#1e1e1e",
                        type: "color",
                    },
                    icon: {
                        width: {
                            value: "24px",
                            type: "dimension",
                        },
                        height: {
                            value: "24px",
                            type: "dimension",
                        },
                        color: {
                            value: "#1e1e1e",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#f4f6f8",
                            type: "color",
                        },
                        borderLeftWidth: {
                            value: "0",
                            type: "dimension",
                        },
                        borderLeftColor: {
                            value: "#2F3B4D",
                            type: "color",
                        },
                    },
                    selected: {
                        color: {
                            value: "#1e1e1e",
                            type: "color",
                        },
                        backgroundColor: {
                            value: "#f4f6f8",
                            type: "color",
                        },
                        borderLeftWidth: {
                            value: "2px",
                            type: "dimension",
                        },
                        borderLeftColor: {
                            value: "#2F3B4D",
                            type: "color",
                        },
                        icon: {
                            color: {
                                value: "#1e1e1e",
                                type: "color",
                            },
                        },
                    },
                },
            },
            footer: {
                paddingHorizontal: {
                    value: "8px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
                borderTopWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderTopColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                logo: {
                    height: {
                        value: "32px",
                        type: "dimension",
                    },
                },
                version: {
                    fontSize: {
                        value: "0.875rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.125rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "fontWeight",
                    },
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
